<template>
  <header class="w-100 d-flex justify-content-between align-items-end">
    <router-link to="/">
      <Logo/>
    </router-link>
  </header>
</template>

<script>
const Logo = () => import('../components/Logo')

export default {
  components: {
    Logo
  }
}
</script>